interface MultiValueRowProps {
  label: string;
  values: Array<{
    key: string;
    value: string | null | undefined;
  }>;
  formatFunction: (value: any) => string;
}

const MultiValueRow = ({
  label,
  values,
  formatFunction
}: MultiValueRowProps) => {
  return (
    <div className='flex justify-between py-2 border-t border-gray-200 dark:border-gray-700'>
      <div className='text-[10px] text-gray-700 dark:text-gray-400'>
        {label}
      </div>
      <div className='flex flex-col gap-2'>
        {values.map(({ key, value }) => (
          <div key={key} className='flex justify-between'>
            <span className='text-[10px] text-gray-700 dark:text-gray-400'>
              {key}:
            </span>
            <span className='text-[10px] dark:text-white'>
              {formatFunction(value)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiValueRow;
